module.exports = __webpack_public_path__ + "static/media/Turkmenistan - TM.5fc29515.png";